/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskExclusionsCreate } from "../funcs/riskExclusionsCreate.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RiskExclusion } from "../models/components/riskexclusion.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CreateRiskExclusionRequest,
  CreateRiskExclusionSecurity,
} from "../models/operations/createriskexclusion.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type RiskCreateExclusionMutationVariables = {
  request: CreateRiskExclusionRequest;
  security?: CreateRiskExclusionSecurity | undefined;
  options?: RequestOptions;
};

export type RiskCreateExclusionMutationData = RiskExclusion;

export type RiskCreateExclusionMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * createRiskExclusion risk
 *
 * @remarks
 * Create a risk exclusion. Omit risk_policy_id to create a global exclusion that applies to every policy in the project.
 */
export function useRiskCreateExclusionMutation(
  options?: MutationHookOptions<
    RiskCreateExclusionMutationData,
    RiskCreateExclusionMutationError,
    RiskCreateExclusionMutationVariables
  >,
): UseMutationResult<
  RiskCreateExclusionMutationData,
  RiskCreateExclusionMutationError,
  RiskCreateExclusionMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildRiskCreateExclusionMutation(client, options),
    ...options,
  });
}

export function mutationKeyRiskCreateExclusion(): MutationKey {
  return ["@gram/client", "exclusions", "create"];
}

export function buildRiskCreateExclusionMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: RiskCreateExclusionMutationVariables,
  ) => Promise<RiskCreateExclusionMutationData>;
} {
  return {
    mutationKey: mutationKeyRiskCreateExclusion(),
    mutationFn: function riskCreateExclusionMutationFn({
      request,
      security,
      options,
    }): Promise<RiskCreateExclusionMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(riskExclusionsCreate(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
